import { Save } from 'lucide-react';
import { useState } from 'react';

const CreateLecturerModal = ({ onClose }) => {
    // State for form data
    const [formData, setFormData] = useState({
        academic_position: '',
        first_name: '',
        last_name: '',
        email: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/settings/addLecturer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },

                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error(`Błąd serwera: ${response.status}`);
            }

            setFormData({
                academic_position: '',
                first_name: '',
                last_name: '',
                email: ''
            });

            onClose();
        } catch (error) {
            console.error('Error adding lecturer:', error);
        }
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="modal-title">Dodaj nauczyciela</h3>
                <form>
                    <div className="form-group">
                        <label>Stopień naukowy:</label>
                        <select
                            name='academic_position'
                            className='form-input'
                            value={formData.academic_position}
                            onChange={handleChange}
                        >
                            <option value="">-- Wybierz --</option>
                            <option value='lic'>Licencjat</option>
                            <option value="Inż">Inżynier</option>
                            <option value="Mgr">Magister</option>
                            <option value="Mgr inż">Magister inżynier</option>
                            <option value="Dr">Doktor</option>
                            <option value="Dr hab">Doktor habilitowany</option>
                            <option value="Prof">Profesor</option>
                        </select>
                        <label>Imię:</label>
                        <input
                            type='text'
                            name='first_name'
                            className='form-input-lecturer'
                            onChange={handleChange}
                        />
                        <label>Nazwisko:</label>
                        <input
                            type='text'
                            name='last_name'
                            className='form-input-lecturer'
                            onChange={handleChange}
                        />
                        <label>Email:</label>
                        <input
                            type='email'
                            name='email'
                            className='form-input-lecturer'
                            onChange={handleChange}
                        />
                        <div className="modal-actions">
                            <button onClick={onClose} className="button-secondary">Anuluj</button>
                            <button onClick={handleSubmit} className="button-primary">
                                <Save size={16} />
                                <span>Zapisz</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default CreateLecturerModal;